import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { RecommendedProgramsDialog } from "./RecommendedProgramsDialog";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
export var RecommendedProgramsDialogLoader = function RecommendedProgramsDialogLoader() {
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showRecommendedProgramsDialog = _useState2[0],
    setShowRecommendedProgramsDialog = _useState2[1];
  var history = useHistory();

  // listen for URL changes: other actions could try to open the recommended programs modal
  // eslint-disable-next-line no-restricted-syntax -- This useEffect should be fine since we're subscribing to a history change
  useEffect(function () {
    var unlisten = history.listen(function (_ref) {
      var hash = _ref.hash,
        pathname = _ref.pathname;
      if (hash === '#see-recommended-programs') {
        setShowRecommendedProgramsDialog(true);
        // use window history object to avoid rendering
        window.history.pushState({}, '', pathname);
      }
    });
    return unlisten;
  }, [history]);

  // check on load if the recommended programs modal should open
  // eslint-disable-next-line no-restricted-syntax -- This useEffect should be fine since we're subscribing to a history change
  useEffect(function () {
    if (history.location.hash === '#see-recommended-programs') {
      setShowRecommendedProgramsDialog(true);
      // use window history object to avoid rendering
      window.history.pushState({}, '', history.location.pathname);
    }
  }, [history]);
  return _jsx(RecommendedProgramsDialog, {
    triggerSettings: {
      hide: true
    }
    // Currently, the 'origin' value 'hash url' is only used for the link that CX may
    // insert in an application's note to trigger the recommended programs dialog. If
    // we receive this'hash url' from another source in the future, we may need to adjust
    // the 'origin' value to differentiate between these two use-cases.
    ,
    origin: "hash url",
    isOpen: showRecommendedProgramsDialog,
    onOpenChange: setShowRecommendedProgramsDialog
  });
};